<div class="main-container">
    <div class="filter-container">
        <h2 style="align-items: flex-end;">
            <div
                style="background-color: var(--primary-500); display: flex; border-radius: 7px; width: 27px; height: 30px;">
                <img [src]="mainIcon" alt="mainIcon" style="filter: brightness(0) invert(1); object-fit: cover;">
            </div>
            Filter
        </h2>
        <p>Filename</p>
        <input [(ngModel)]="filterName" type="text" pInputText placeholder="Enter Filename">
        <p>Start Date</p>
        <p-calendar [(ngModel)]="filterStartDate" [maxDate]="todayDate" [showIcon]="true" appendTo="body"
            placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <p>End Date</p>
        <p-calendar [(ngModel)]="filterEndDate" [maxDate]="todayDate" [showIcon]="true" appendTo="body"
            placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <div class="button-container">
            <p-button label="Clear" (onClick)="onClearClick()" [outlined]="true" styleClass="clearBtn"></p-button>
            <p-button label="Apply" (onClick)="onApplyClick()"></p-button>
        </div>
    </div>

    <div class="result-container">
        <div class="top-section">
            <p></p>
            <p-button *ngIf="requestReplaceList" label="Reset GeoCode Data" (onClick)="onImportClick('reset')"
                icon="pi createIcon"></p-button>
            <p-button *ngIf="!requestReplaceList" label="Import GeoCode Data" (onClick)="onImportClick('import')"
                icon="pi createIcon"></p-button>
            <p-button label="Export GeoCode Data" (onClick)="onExportClick()" icon="pi createIcon"></p-button>
            <p-button label="Download Templete" (onClick)="onDownloadTemplete()" icon="pi downloadIcon"></p-button>
        </div>

        <div class="replace-container" *ngIf="requestReplaceList">
            <ng-container>
                <div *ngFor="let row of requestReplaceList;">
                    <div class="replace-header">
                        <div class="replace-info" [ngStyle]="{'width': '30%'}">
                            <strong>Filename:</strong> <span [pTooltip]="row.Filename" tooltipPosition="top"> {{
                                row.Filename }}</span>
                        </div>
                        <div class="replace-info" [ngStyle]="{'width': '30%'}">
                            <strong>Upload Date:</strong> <span> {{ row.Date | date: 'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="replace-info" [ngStyle]="{'width': '30%'}">
                            <strong>Quantity:</strong> <span> {{ row.Quantity }}</span>
                        </div>
                        <div class="replace-button" [ngStyle]="{'width': '10%'}">
                            <p-button icon="pi downloadIcon-geocode" pTooltip="Download" tooltipPosition="top"
                                severity="info" [text]="true" [rounded]="true"
                                (onClick)="onDownloadClick(row)"></p-button>
                            <p-button (onClick)="onDeleteClick(row)" icon="pi deleteIconGeocode" severity="danger"
                                [text]="true" [rounded]="true" pTooltip="Delete" tooltipPosition="top"></p-button>
                        </div>
                    </div>

                    <div class="replace-body">
                        <strong>Information:</strong>
                        <div class="information-box">
                            {{ row.Information }}
                        </div>

                    </div>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="!requestReplaceList">
            <div class="upload" style=" width: 100%; margin-top: 6%;">
                <div (click)="onImportClick('import')">
                    <i class="pi pi-cloud-upload icon-upload" style="font-size: 70px;"></i>
                </div>
                <p>Click to import geocode file.</p>
            </div>
        </ng-container>

        <div class="top-section" *ngIf="requestReplaceList">
            <p></p>
            <p-button label="Upload Addtional GeoCode Data" (onClick)="onUploadClick()" icon="pi createIcon"></p-button>
        </div>

        <p-table [value]="requestAppendList" (onSort)="onSort($event)" *ngIf="requestReplaceList">
            <ng-template pTemplate="header">
                <tr>
                    <th [ngStyle]="{'width': '20%', 'border-top-left-radius': '20px', 'border-bottom-left-radius': '20px'} "
                        pSortableColumn="Filename">
                        FileName <p-sortIcon field="Filename" /> </th>
                    <th [ngStyle]="{'width': '12%'}" pSortableColumn="Date">Date <p-sortIcon field="Date" /></th>
                    <th [ngStyle]="{'width': '20%'}">Information</th>
                    <th [ngStyle]="{'width': '13%'}" pSortableColumn="Quantity"> Quantity <p-sortIcon
                            field="Quantity" /></th>
                    <th class="center-th update" [ngStyle]="{'width': '20%'}">UpdateType </th>
                    <th class="center-th action"
                        [ngStyle]="{'width': '15%', 'border-top-right-radius': '20px', 'border-bottom-right-radius': '20px'}">
                        Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-appendRowData>
                <tr *ngIf="requestAppendList && requestAppendList.length > 0">
                    <td
                        [ngStyle]="{'width': '20%', 'border-top-left-radius': '20px', 'border-bottom-left-radius': '20px'} ">
                        <div class="file-name">
                            <span [pTooltip]="appendRowData.Filename" tooltipPosition="top">{{appendRowData.Filename
                                }}</span>
                        </div>
                    </td>
                    <td [ngStyle]="{'width': '12%'}">{{ appendRowData. Date | date: 'dd/MM/yyyy' }}</td>
                    <td [ngStyle]="{'width': '20%'}">
                        <div class="info"><span [pTooltip]="appendRowData.Information"
                                tooltipPosition="top">{{appendRowData.Information }}</span></div>
                        <!-- [autoHide]="false" -->
                    </td>
                    <td [ngStyle]="{'width': '13%'}">{{ appendRowData.Quantity }}</td>
                    <td [ngStyle]="{'width': '20%'}">
                        <div class="type-container">
                            <div class="update-type"
                                [ngClass]="[getUpdateTypeClass(appendRowData.UpdateType),'text-type']">
                                {{appendRowData.UpdateType}}</div>
                        </div>
                    </td>
                    <td
                        [ngStyle]="{'width': '15%', 'border-top-right-radius': '20px', 'border-bottom-right-radius': '20px'}">
                        <div class="button-container">
                            <p-button icon="pi downloadIcon-geocode" pTooltip="Download" tooltipPosition="top"
                                severity="info" [text]="true" [rounded]="true"
                                (onClick)="onDownloadClick(appendRowData)"></p-button>
                            <p-button (onClick)="onDeleteClick(appendRowData)" icon="pi deleteIconGeocode"
                                severity="danger" [text]="true" [rounded]="true" pTooltip="Delete"
                                tooltipPosition="top"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <ng-container *ngIf="requestAppendList.length === 0 && requestReplaceList">
            <div class="upload" style=" width: 100%;">
                <div (click)="onUploadClick()">
                    <i class="pi pi-cloud-upload icon-upload" style="font-size: 70px;"></i>
                </div>
                <p>Click to upload additional geocode file.</p>
            </div>
        </ng-container>
        <div class="bottom-section" *ngIf="requestAppendList && requestAppendList.length > 0">
            <p-dropdown [(ngModel)]="pageSize" [options]="pageSizeList"
                (onChange)="onPageSizeChange($event)"></p-dropdown>
            <p>{{ getRequestBegin() + 1 }} ถึง {{ getRequestEnd() }} จาก {{ totalRecordAppend ? totalRecordAppend : 0 }}
                รายการ</p>
            <div class="button-container">
                <button (click)="onToBeginningClick()"><img [src]="toBeginningIcon" alt="beginning"></button>
                <button (click)="onBackClick()"><img [src]="backIcon" alt="back"></button>
                <button class="pageBtn" *ngFor="let i of [4, 3, 2, 1]" (click)="goto(currentPage - i)"
                    [ngClass]="{'hidden': !isActiveButton(currentPage - i)}">{{ currentPage - i }}</button>
                <button (click)="onPageNumberClick()" class="currentBtn">{{ currentPage }}</button>
                <button class="pageBtn" *ngFor="let i of [1, 2, 3, 4]" (click)="goto(currentPage + i)"
                    [ngClass]="{'hidden': !isActiveButton(currentPage + i)}">{{ currentPage + i }}</button>
                <button (click)="onNextClick()"><img [src]="nextIcon" alt="next"></button>
                <button (click)="onToLastClick()"><img [src]="toLastIcon" alt="last"></button>
            </div>
            <p-dialog [style]="{'width': 'fit-content', 'height': 'fit-contenet'}" [(visible)]="goto_dialog_visible"
                [modal]="true" [draggable]="false" [resizable]="false">
                <div class="dialog-container">
                    Goto: <p-dropdown [(ngModel)]="gotoPage" [options]="getGotoOptions()" appendTo="body"></p-dropdown>
                    <button (click)="onGotoClick()">Go</button>
                </div>
            </p-dialog>
        </div>
    </div>
    <p-toast></p-toast>
    <p-confirmDialog #cd [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <h3>Confirmation</h3>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template>
    </p-confirmDialog>
    <p-dialog [style]="{'width': '50vw'}" [(visible)]="dialog_visible" [modal]="true" [draggable]="false"
        [resizable]="false" [closable]="false">
        <div class="dialog-container">
            <h2 [ngSwitch]="dialogAction">
                <ng-container *ngSwitchCase="'import'">Import GeoCode Data</ng-container>
                <ng-container *ngSwitchCase="'reset'">Reset GeoCode Data</ng-container>
                <ng-container *ngSwitchCase="'upload'">Upload GeoCode Data</ng-container>
            </h2>

            <p>File Browser</p>
            <p></p>
            <p-fileUpload #fileUpload name="file[]" accept=".txt, .csv, .docx, .xls, .xlsx"
                (onSelect)="uploadHandler($event)" [showUploadButton]="false" (onRemove)="onRemove($event)"
                (onClear)="onRemove($event)" chooseLabel="Browse" [multiple]="false"></p-fileUpload>
            <p></p>
            <div *ngIf="uploadedFiles">
                <div class="input-information">
                    <p>Information</p>
                    <textarea type="text" maxlength="256" [(ngModel)]="information" pInputTextarea
                        [style]="{'width': '100%', 'margin-bottom': '20px'}" #informationTextarea></textarea>
                    <span class="text-length">{{ informationTextarea.value.length }}/256</span>
                </div>

                <p></p>
            </div>
            <div class="button-container">
                <p-button label="Cancel" [outlined]="true" (onClick)="onCancelClick()"
                    styleClass="cancelBtn"></p-button>
                <div *ngIf="isAppend">
                    <p-button label="Save" (onClick)="onFileSaveAppendClick()"></p-button>
                </div>
                <div *ngIf="!isAppend">
                    <p-button label="Save" (onClick)="onFileSaveReplaceClick()"></p-button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>